//2026 Global Polling Settings
window.polling_settings = {
	maxAttempts: 20, //20 attempts
	interval: 500, //500ms interval
};

window.DEBUG_MODE = true;
if (typeof window.logDebug !== 'function') {
	window.logDebug = function(label, ...args) {
		if (!window.DEBUG_MODE) return;
		const iconMap = {
			event: "🎯",
			error: "❌",
			warn: "⚠️",
			ready: "✅",
			price: "💲",
			widget: "🧩",
			fetch: "🌐",
			cart: "🛒",
			discount: "🏷️",
			cookie: "🍪",
			function: "🔧",
			validate: "✔️",
			debug: "🐛",
			autoapply: "🤖",
		};
		let icons = [];
		const l = label.toLowerCase();
		for (const [key, icon] of Object.entries(iconMap)) {
			if (l.includes(key)) icons.push(icon);
		}
		if (icons.length === 0) icons.push("🐛"); // default
		console.log(`${icons.join("")} [${label}]`, ...args);
	};
}

//window.logDebug('debug_tag','{{ debug_tag }}');
//window.logDebug('window.has_noRecharge_tag', product_tags, window.has_noRecharge_tag);

// Global settings for discount config


//console.debug('product-.min.js-shopify-DEBUG');
window.addEventListener('DOMContentLoaded', function() {

	/**
	 * Initialize Recharge-related hooks. 2026
	 */
	const rechargeContainer = document.querySelector('div.product-information');
	//window.logDebug('[Recharge] validation >>', rechargeContainer, window.has_noRecharge_tag);
	if (rechargeContainer && !window.has_noRecharge_tag) {
		//window.logDebug('[Recharge] validation >> create observer');
		const observer = new MutationObserver((mutations, obs) => {
			if (rechargeContainer.querySelector('.rc-widget, recharge-subscription-widget')) {
				obs.disconnect();
				document.body.setAttribute('has-recharge', '1');
			}
		});

		observer.observe(rechargeContainer, {
			childList: true,
			subtree: true
		});

		setTimeout(() => {
			observer.disconnect();
			if (!document.body.getAttribute('has-recharge')) {
				document.body.setAttribute('has-recharge', '0');
				window.logDebug('[Recharge] Widget never appeared (MutationObserver timeout).');
			}
		}, window.polling_settings.interval * window.polling_settings.maxAttempts);
	} else {
		document.body.setAttribute('has-recharge', '-1');
		window.logDebug('[Recharge] No recharge container needed (noRecharge tag present).');
	}



	if (!customElements.get('variant-selects')) {
		console.debug('product-add-to-cart_mod-DEBUG');
		/**
		 *  @class
		 *  @function VariantSelects
		 */
		class VariantSelects extends HTMLElement {
			constructor() {
				super();
				this.addEventListener('change', this.onVariantChange);
			}

			onVariantChange() {
				this.updateOptions();
				this.updateMasterId();
				this.toggleAddButton(true, '', false);
				this.updatePickupAvailability();
				this.removeErrorMessage();
				this.updateVariantText();
				//this.updateDiscountPrice();

				if (!this.currentVariant) {
					this.toggleAddButton(true, '', true);
					this.setUnavailable();
				} else {
					this.updateMedia();
					this.updateURL();
					this.updateVariantInput();

					this.renderProductInfo();
					//this.updateShareUrl();
				}
			}

			updateOptions() {
				const fieldsets = Array.from(this.querySelectorAll('fieldset'));
				this.options = [];
				fieldsets.forEach((fieldset, i) => {
					if (fieldset.querySelector('select')) {
						this.options.push(fieldset.querySelector('select').value);
						let selectEl = fieldset.querySelector('select').value;
						console.log(`Updated option to ID to: ${selectEl}`);
					} else if (fieldset.querySelectorAll('input').length) {
						this.options.push(fieldset.querySelector('input:checked').value);
						let selectEl = fieldset.querySelector('input:checked').value;
						console.log(`Updated option to ID to: ${selectEl}`);
					}
				});
			}
			updateVariantText() {
				const fieldsets = Array.from(this.querySelectorAll('fieldset'));
				fieldsets.forEach((item, i) => {
					let label = item.querySelector('.form__label__value');
					if (label) {
						label.innerHTML = this.options[i];
					}
				});
			}
			updateMasterId() {
				this.currentVariant = this.getVariantData().find((variant) => {
					return !variant.options
						.map((option, index) => {
							return this.options[index] === option;
						})
						.includes(false);
				});
			}

			updateMedia() {
				if (!this.currentVariant) return;
				if (!this.currentVariant.featured_media) return;

				let productSlider = this.closest('.thb-product-detail').querySelector('.product-images');

				if (!productSlider) {
					productSlider = document.getElementById('Product-Quick-Slider');
				}
				this.setActiveMedia(
					`#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`,
					productSlider
				);
			}
			setActiveMedia(mediaId, productSlider) {
				var flkty = Flickity.data(productSlider);

				if (flkty) {
					flkty.selectCell(mediaId);
				}
			}

			updateURL() {
				if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
				window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
			}

			updateShareUrl() {
				const shareButton = document.getElementById(`Share-${this.dataset.section}`);
				if (!shareButton) return;
				shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
			}

			updateVariantInput() {
				const productForms = document.querySelectorAll(
					`#product-form-${this.dataset.section}, #product-form-installment`
				);
				productForms.forEach((productForm) => {
					const input = productForm.querySelector('input[name="id"]');
					input.value = this.currentVariant.id;
					//console.log(`Updated variant ID to: ${this.currentVariant.id}`);

					input.dispatchEvent(
						new Event('change', {
							bubbles: true,
						})
					);
				});
			}

			updatePickupAvailability() {
				const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

				if (!pickUpAvailability) return;

				if (this.currentVariant && this.currentVariant.available) {
					pickUpAvailability.fetchAvailability(this.currentVariant.id);
				} else {
					pickUpAvailability.removeAttribute('available');
					pickUpAvailability.innerHTML = '';
				}
			}

			removeErrorMessage() {
				const section = this.closest('section');
				if (!section) return;

				const productForm = section.querySelector('product-form');
				if (productForm) productForm.handleErrorMessage();
			}

			renderProductInfo() {
				fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
					.then((response) => response.text())
					.then((responseText) => {
						const id = `price-${this.dataset.section}`;
						const html = new DOMParser().parseFromString(responseText, 'text/html');
						const destination = document.getElementById(id);
						const source = html.getElementById(id);

						if (source && destination) destination.innerHTML = source.innerHTML;

						const price = document.getElementById(`price-${this.dataset.section}`);

						if (price) price.classList.remove('visibility-hidden');
						this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);
					});
			}

			toggleAddButton(disable = true, text = false, modifyClass = true) {
				const productForm = document.getElementById(`product-form-${this.dataset.section}`);
				if (!productForm) return;
				const addButton = productForm.querySelector('[name="add"]');
				const addButtonText = productForm.querySelector('[name="add"] > span');

				if (!addButton) return;

				if (disable) {
					addButton.setAttribute('disabled', 'disabled');
					if (text) addButtonText.textContent = text;
				} else {
					addButton.removeAttribute('disabled');
					addButton.classList.remove('loading');
					addButtonText.textContent = window.theme.variantStrings.addToCart;
				}

				if (!modifyClass) return;
			}

			setUnavailable() {
				const button = document.getElementById(`product-form-${this.dataset.section}`);
				const addButton = button.querySelector('[name="add"]');
				const addButtonText = button.querySelector('[name="add"] > span');
				const price = document.getElementById(`price-${this.dataset.section}`);
				if (!addButton) return;
				addButtonText.textContent = window.theme.variantStrings.unavailable;
				addButton.classList.add('sold-out');
				if (price) price.classList.add('visibility-hidden');
			}

			getVariantData() {
				this.variantData =
					this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
				return this.variantData;
			}

			waitForElement(selector, callback, interval = 100, maxAttempts = 5, initialDelay = 2000) {
				let attempts = 0;

				function checkForElement() {
					const element = document.querySelector(selector);
					if (element) {
						callback(element);
					} else if (attempts < maxAttempts) {
						attempts++;
						setTimeout(checkForElement, interval);
					} else {
						console.warn(`Element ${selector} not found after ${maxAttempts} attempts`);
					}
				}
				setTimeout(checkForElement, initialDelay);
			}

			updateDiscountPrice() {
				// DISCOUNT CONFIG 2025 NOT ENABLED
				//data-v-id
				console.debug('updateDiscountPrice-DEBUG');
				const prcPriceEl = document.querySelector('[name="properties[_PrcPrice]"]');
				const formEl = document.querySelector('#product-form-installment');
				const compareAtPriceEl = formEl ? formEl.querySelector('[name="amount_discount"]') : false;
				const compareAtPriceListEl = formEl ? formEl.querySelector('[name="amount_discount_list"]') : false;

				if (!compareAtPriceListEl || !prcPriceEl) return;

				const foundOption = Array.from(compareAtPriceListEl.options).find(
					(option) => option.text === this.currentVariant.title
				);
				if (!foundOption) return;

				if (compareAtPriceEl) compareAtPriceEl.value = foundOption.value;
				//prcPriceEl.value = foundOption.dataset.price
				let valuePrice = foundOption.value;
				valuePrice = parseFloat(valuePrice.replace(/[^0-9.]/g, ''));
				valuePrice = valuePrice > foundOption.dataset.price ? valuePrice : foundOption.dataset.price;
				prcPriceEl.value = valuePrice;

				//console.debug('product-.min.js-updatePrcPrice-DEBUG>>', valuePrice);

				//prcPriceEl.value = foundOption.value

				//console.debug('product-.min.js-updatePrcPrice-DEBUG', prcPriceEl.value);
				//2024 Subscription Discount update

				console.debug('updateDiscountPrice-DEBUG >> A');

				const discountPrcPriceEl = document.querySelector('[name="properties[_PrcPrice_Discount_PrcPrice]"]');
				const discountBaseEl = document.querySelector('[name="properties[_PrcPrice_Discount_Base]"]');
				const discountDiscountEl = document.querySelector('[name="properties[_PrcPrice_Discount]"]');
				discountBaseEl.value = valuePrice;
				discountDiscountEl.dataset.comparePrice = valuePrice;
				//update 6/26/2024
				discountPrcPriceEl.value = valuePrice;

				this.waitForElement(
					'.price .amount',
					(element) => {
						const amountPrice = element.textContent.trim().replace('$', '');
						const discountOriginalEl = document.querySelector('[name="properties[_PrcPrice_Discount_Original]"]');
						discountOriginalEl.value = amountPrice;
						//console.debug('product-.min.js-updatePrcPrice-DEBUG [found]', amountPrice);
					},
					100,
					5,
					400
				);
			}
		}
		customElements.define('variant-selects', VariantSelects);

		/**
		 *  @class
		 *  @function VariantRadios
		 */
		class VariantRadios extends VariantSelects {
			constructor() {
				super();
			}

			updateOptions() {
				const fieldsets = Array.from(this.querySelectorAll('fieldset'));
				this.options = fieldsets.map((fieldset) => {
					return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
				});
			}
			updateVariantText() {}
		}

		customElements.define('variant-radios', VariantRadios);
	}
	if (!customElements.get('product-slider')) {
		/**
		 *  @class
		 *  @function ProductSlider
		 */
		class ProductSlider extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('change', this.setupProductGallery);
			}
			connectedCallback() {
				const _this = this;
				const product_container = this.closest('.thb-product-detail');
				const thumbnail_container = product_container.querySelector('.product-thumbnail-container');
				const prev_button = this.querySelector('.flickity-prev');
				const next_button = this.querySelector('.flickity-next');
				const thumbnails = thumbnail_container.querySelectorAll('.product-thumbnail');
				const flkty = new Flickity(this, {
					wrapAround: true,
					pageDots: true,
					contain: true,
					adaptiveHeight: true,
					initialIndex: '.is-initial-selected',
					prevNextButtons: false,
					fade: false,
					cellSelector: '.product-images__slide',
				});
				let selectedIndex = flkty.selectedIndex;
				if (prev_button) {
					prev_button.addEventListener('click', (event) => {
						flkty.previous();
					});
					prev_button.addEventListener('keyup', (event) => {
						flkty.previous();
						event.preventDefault();
					});
				}
				if (next_button) {
					next_button.addEventListener('click', (event) => {
						flkty.next();
					});
					next_button.addEventListener('keyup', (event) => {
						flkty.next();
						event.preventDefault();
					});
				}
				flkty.on('settle', function(index) {
					selectedIndex = index;
				});
				flkty.on('change', function(index) {
					let previous_slide = flkty.cells[selectedIndex].element,
						previous_media = previous_slide.querySelector('.product-single__media'),
						slide = flkty.cells[index].element,
						media = slide.querySelector('.product-single__media'),
						active_thumb = thumbnails[index];

					thumbnails.forEach((item, i) => {
						item.classList.remove('is-initial-selected');
					});
					active_thumb.classList.add('is-initial-selected');
					requestAnimationFrame(() => {
						if (active_thumb.offsetParent === null) {
							return;
						}
						const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
							windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
						active_thumb.parentElement.scrollTo({
							left: 0,
							top: active_thumb.offsetTop - windowHalfHeight + active_thumb.clientHeight / 2,
							behavior: 'smooth',
						});
					});

					// Stop previous video
					if (previous_media.classList.contains('product-single__media-external-video')) {
						if (previous_media.dataset.provider === 'youtube') {
							previous_media
								.querySelector('iframe')
								.contentWindow.postMessage(JSON.stringify({
									event: 'command',
									func: 'pauseVideo',
									args: ''
								}), '*');
						} else if (previous_media.dataset.provider === 'vimeo') {
							previous_media
								.querySelector('iframe')
								.contentWindow.postMessage(JSON.stringify({
									method: 'pause'
								}), '*');
						}
					} else if (previous_media.classList.contains('product-single__media-native-video')) {
						previous_media.querySelector('video').pause();
					}

					// Draggable.
					if (media.classList.contains('product-single__media-model')) {
						_this.setDraggable(flkty, false);
					} else {
						_this.setDraggable(flkty, true);
					}
				});

				thumbnails.forEach((thumbnail, index) => {
					thumbnail.addEventListener('click', function() {
						[].forEach.call(thumbnails, function(el) {
							el.classList.remove('is-initial-selected');
						});
						thumbnail.classList.add('is-initial-selected');
						flkty.select(index);
					});
				});

				// Start Gallery
				this.setupProductGallery();
			}
			setDraggable(flkty, draggable) {
				flkty.options.draggable = draggable;
				flkty.updateDraggable();
			}
			setupProductGallery() {
				if (!this.querySelectorAll('.product-single__media-zoom').length) {
					return;
				}
				let activeImages = Array.from(this.querySelectorAll('.product-single__media-image'));

				this.setEventListeners(this, activeImages);
			}
			buildItems(activeImages) {
				let images = activeImages.map((item) => {
					let activelink = item.querySelector('.product-single__media-zoom');
					return {
						src: activelink.getAttribute('href'),
						msrc: activelink.dataset.msrc,
						w: activelink.dataset.w,
						h: activelink.dataset.h,
					};
				});
				return images;
			}
			setEventListeners(container, activeImages) {
				let links = container.querySelectorAll('.product-single__media-zoom'),
					items = container.buildItems(activeImages),
					pswpElement = document.querySelectorAll('.pswp')[0],
					options = {
						maxSpreadZoom: 2,
						loop: false,
						allowPanToNext: false,
						closeOnScroll: false,
						showHideOpacity: false,
						arrowKeys: true,
						history: false,
						captionEl: false,
						fullscreenEl: false,
						zoomEl: false,
						shareEl: false,
						counterEl: false,
						arrowEl: true,
						preloaderEl: true,
						getThumbBoundsFn: () => {
							const thumbnail = container.querySelector('.product-images__slide.is-selected'),
								pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
								rect = thumbnail.getBoundingClientRect();
							return {
								x: rect.left,
								y: rect.top + pageYScroll,
								w: rect.width
							};
						},
					};

				links.forEach((link) => {
					link.addEventListener('click', (event) => {
						let i = link.dataset.index;
						options.index = parseInt(i, 10);

						if (typeof PhotoSwipe !== 'undefined') {
							let pswp = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
							pswp.listen('firstUpdate', function() {
								pswp.listen('parseVerticalMargin', function(item) {
									item.vGap = {
										top: 50,
										bottom: 50
									};
								});
							});
							pswp.init();
						}
						event.preventDefault();
					});
				});
			}
		}
		customElements.define('product-slider', ProductSlider);
	}

	/**
	 *  @class
	 *  @function ProductForm
	 */
	if (!customElements.get('product-form')) {
		customElements.define(
			'product-form',
			class ProductForm extends HTMLElement {
				constructor() {
					super();
					/* update moved to connectedCallback 2025 */
				}

				connectedCallback() {
					this.form = this.querySelector('form');
					this.form.querySelector('[name=id]').disabled = false;
					this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
					this.cartNotification = document.querySelector('cart-notification');
					this.body = document.body;
				}



				applyDiscountIfNeeded() {
					const body = document.body; // use <body> instead of <html>
					const discountCode = body.getAttribute('has-discount') || '';
					const discountActive = body.getAttribute('has-discount-active') || '';

					console.debug('Discount code present:', discountCode);
					console.debug('Discount active status:', discountActive);

					if (discountCode && !discountActive) {
						console.debug('Applying discount code:', discountCode);
						// Apply one code
						return fetch(`${window.Shopify.routes.root}cart/update.js`, {
							method: 'POST',
							headers: {
								'Content-Type': 'application/json'
							},
							body: JSON.stringify({
								discount: `${discountCode}`
							})
						}).then(r => r.json());
					}

					// Nothing to do; still return a promise so callers can await.
					return Promise.resolve(null);
				}

				async onSubmitHandler(evt) {
					evt.preventDefault();
					console.debug('onSubmitHandler:product:shopify');

					//2025
					/* DISCOUNT CONFIG 2025 REMOVED */
					window.prc.setPrcCodeAutoApply();

					const submitButton = this.querySelector('[type="submit"]');
					if (submitButton.classList.contains('loading')) return;

					this.handleErrorMessage();

					submitButton.setAttribute('aria-disabled', true);
					submitButton.classList.add('loading');


					// --- PATCH (moved out) ---
					await this.applyDiscountIfNeeded(); // waits until finished
					// --- END PATCH ---


					const config = {
						method: 'POST',
						headers: {
							'X-Requested-With': 'XMLHttpRequest',
							Accept: 'application/javascript',
						},
					};
					const formData = new FormData(this.form);
					//PATCH 2024 NOT USED
					/* DISCOUNT CONFIG 2025 REMOVED
					if (formData.has('properties[_PrcPrice]')) {
					  let formDataField = formData.get('properties[_PrcPrice]');
					  let formDataFieldConv = formDataField.replace('.', '');
					  let formDataFieldConvithZeros = formDataField.padStart(4, '0');
					}
					*/
					//console.log(this.form);
					//window.logDebug('onSubmitHandler',this.form);

					formData.append(
						'sections',
						this.getSectionsToRender().map((section) => section.section)
					);
					formData.append('sections_url', window.location.pathname);

					config.body = formData;
					//console.debug('product-.min.js-onSubmitHandler-DEBUG', config.body);
					/*
					for (let [key, value] of config.body.entries()) {
					  console.log(key + ':', value);
					}
					console.log('SENDING');
					*/
					// console.log(config);
					fetch(`${theme.routes.cart_add_url}`, config)
						.then((response) => {
							// 2025 patch console.log(response); // Output the response object
							return response.json();
						})
						.then((response) => {
							// 2025 patch console.log(response); // Output the parsed JSON response
							if (response.status) {
								this.handleErrorMessage(response.description);
								return;
							}
							this.renderContents(response);
						})
						.catch((e) => {
							console.error(e);
						})
						.finally(() => {
							submitButton.classList.remove('loading');
							submitButton.removeAttribute('aria-disabled');
						});
				}

				/* DISCOUNT CONFIG 2025 NOT USED */
				async updateLineItemsProperties(lineItems, isRemovePrc = false) {
					console.log('product-.min.js-updateLineItemsProperties-DEBUG');
					for (let index = 0; index < lineItems.length; index++) {
						const item = lineItems[index];
						const properties = {
							...item.properties,
						};
						if (isRemovePrc) {
							delete properties._PrcCode;
							delete properties._ValidPrc;
						}
						if (!isRemovePrc) {
							properties._PrcCode = window.prc.code;
							properties._ValidPrc = 'true';
						}
						await fetch(`${theme.routes.cart_change_url}.js`, {
							method: 'POST',
							headers: {
								'Content-Type': 'application/json',
							},
							body: JSON.stringify({
								id: item.key,
								properties,
							}),
						});
					}
				}

				getSectionsToRender() {
					return [{
							id: 'Cart',
							section: 'main-cart',
							selector: '.thb-cart-form',
						},
						{
							id: 'Cart-Drawer',
							section: 'cart-drawer',
							selector: '.cart-drawer',
						},
						{
							id: 'cart-drawer-toggle',
							section: 'cart-bubble',
							selector: '.thb-item-count',
						},
					];
				}
				renderContents(parsedState) {
					this.getSectionsToRender().forEach((section) => {
						if (!document.getElementById(section.id)) {
							return;
						}
						const elementToReplace =
							document.getElementById(section.id).querySelector(section.selector) ||
							document.getElementById(section.id);
						elementToReplace.innerHTML = this.getSectionInnerHTML(
							parsedState.sections[section.section],
							section.selector
						);

						let quantities = elementToReplace.querySelectorAll('.quantity:not(.buttons_added)');

						if (quantities) {
							quantities.forEach((quantity) => {
								new QuantityInput(quantity);
							});
						}
						if (typeof CartDrawer !== 'undefined') {
							new CartDrawer();
						}
						if (typeof Cart !== 'undefined') {
							new Cart().renderContents(parsedState);
						}
					});

					if (document.getElementById('Cart-Drawer')) {
						this.body.classList.add('open-cc');
						document.getElementById('Cart-Drawer').classList.add('active');
					}

					let product_drawer = document.getElementById('Product-Drawer');
					if (product_drawer && product_drawer.contains(this)) {
						product_drawer.classList.remove('active');

						if (!document.getElementById('Cart-Drawer')) {
							this.body.classList.remove('open-cc');
						}
					}
				}
				getSectionInnerHTML(html, selector = '.shopify-section') {
					return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
				}
				handleErrorMessage(errorMessage = false) {
					this.errorMessageWrapper =
						this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
					this.errorMessage =
						this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

					this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

					if (errorMessage) {
						this.errorMessage.textContent = errorMessage;
					}
				}
			}
		);
	}

	//console.debug('product-.min.js_shopify-DEBUG:Discounted subscriptions');
	const findElementAsync = async (selector, interval = window.polling_settings.interval, maxAttempts = window.polling_settings.maxAttempts) => {
		let i;
		let attempts = 0;

		return new Promise((resolve, reject) => {
			i = setInterval(() => {
				attempts++;
				const el = document.querySelector(selector);

				if (el) {
					clearInterval(i);
					resolve(el);
				}

				if (attempts >= maxAttempts) {
					clearInterval(i);
					reject(new Error(`Element not found![pmjsshopify]${selector} attempts: ${attempts}`));
				}
			}, interval);
		});
	};

	//11/2023
	window.clearInfoMessage = () => {
		const customer_code = document.querySelector('[name="customer[code]"]');
		const customer_enter_message = document.querySelector('.ApplyToCart-message-small');
		if (customer_code && customer_enter_message) {
			var customer_code_style = window.getComputedStyle(customer_code);
			var customer_code_display = customer_code_style.display;
			if (
				(customer_code.offsetWidth <= 0 && customer_code.offsetHeight <= 0) ||
				customer_code_display == 'none'
			) {
				customer_enter_message.style.display = 'none';
			}
		}
	};


	/**
	 * Calculates a discounted price.
	 *
	 * @param {string|number} value - The original price.
	 * @param {'dollars'|'string'|'cents'} [inputFormat='dollars'] - Format of the input value.
	 * @param {'number'|'string'|'money'} [outputFormat='money'] - Format of the returned value.
	 * @param { type: 'percent' | 'fixed', value: number } [additionalDiscount] - Optional additional discount to apply after the main discount. Type can be 'percent' (e.g., 5%) or 'fixed' (e.g., $5).
	 * @returns {number|string} - The final discounted price in the desired format.
	 */

	window.calculateDiscountedPrice = (
		value,
		inputFormat = 'dollars',
		outputFormat = 'money',
		additionalDiscount = {
			type: null,
			value: 0
		}
	) => {
		const discountPercent = window.product_min_param_settings.discount_config_flag_value;
		let priceNum;

		// Parse input based on format
		if (inputFormat === 'dollars') {
			priceNum = typeof value === 'number' ? value : parseFloat(value);
		} else if (inputFormat === 'string') {
			const clean = value.replace(/[^0-9.]/g, '');
			priceNum = parseFloat(clean);
		} else if (inputFormat === 'cents') {
			priceNum = (typeof value === 'number' ? value : parseFloat(value)) / 100;
		} else {
			throw new Error("Invalid input format. Use 'dollars', 'string', or 'cents'.");
		}

		// Apply primary discount
		const percentToKeep = (100 - discountPercent) / 100;
		let discountedPrice = priceNum * percentToKeep;

		// Apply additional discount
		if (additionalDiscount && additionalDiscount.value > 0) {
			if (additionalDiscount.type === 'percent') {
				discountedPrice *= (100 - additionalDiscount.value) / 100;
			} else if (additionalDiscount.type === 'fixed') {
				discountedPrice -= additionalDiscount.value;
			}
		}

		// Ensure price doesn't go below zero
		discountedPrice = Math.max(discountedPrice, 0);

		// Return in requested output format
		if (outputFormat === 'number') {
			return discountedPrice;
		} else if (outputFormat === 'string') {
			return discountedPrice.toFixed(2);
		} else if (outputFormat === 'money') {
			return discountedPrice.toLocaleString('en-US', {
				style: 'currency',
				currency: 'USD'
			});
		} else {
			throw new Error("Invalid output format. Use 'number', 'string', or 'money'.");
		}
	};

	/**
	 * Apply a percentage discount to a value and return in your desired format.
	 *
	 * @param {string|number} value - Original price (can be raw number or "$123.45" string)
	 * @param {string|number} percent - Discount percentage to remove (can be number or string)
	 * @param {'number'|'string'|'money'} [format='money'] - Output format
	 * @returns {number|string} - Discounted value
	 */
	window.applyPercentDiscount = (value, percent, format = 'money') => {

		//console.debug('applyPercentDiscount-DEBUG', value, percent, format);
		console.debug('[applyPercentDiscount]');
		// If value is a string like "$130.90", clean it
		if (typeof value === 'string') {
			value = value.replace(/[^0-9.]/g, '');
		}

		if (typeof percent === 'string') {
			percent = percent.replace(/[^0-9.]/g, '');
		}

		// Convert to numbers
		const parsedValue = parseFloat(value);
		const parsedPercent = parseFloat(percent);

		if (isNaN(parsedValue) || isNaN(parsedPercent)) {
			throw new Error("Both value and percent must be numbers or numeric strings.");
		}

		const percentToKeep = (100 - parsedPercent) / 100;
		let discounted = parsedValue * percentToKeep;

		discounted = Math.max(discounted, 0); // Prevent negatives

		if (format === 'number') {
			return discounted;
		} else if (format === 'string') {
			return discounted.toFixed(2);
		} else if (format === 'money') {
			return discounted.toLocaleString('en-US', {
				style: 'currency',
				currency: 'USD'
			});
		} else {
			throw new Error("Invalid format. Use 'number', 'string', or 'money'.");
		}
	};


	//2024
	//Discounted subscriptions
	window.SubscribeAndSaveObserver = {
		on: false,
		startObserver: function() {
			if (this.on) return;
			//console.log('OBSERVING UPDATE');

			const observer = new MutationObserver(function(mutationsList, observer) {
				mutationsList.forEach((mutation) => {
					if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
						const newValue = mutation.target.value;
						/*
                 2025 UPDATE REMOVED
                console.log('Value changed to:', newValue);
                const prcPriceDiscountEl = document.querySelector('[name="properties[_PrcPrice_Discount]"]');
               
                
                if (newValue.trim() == '') {
                  prcPriceDiscountEl.value = 0;
                } else {
                  prcPriceDiscountEl.value = prcPriceDiscountEl.dataset.comparePriceDiscount;
                }
                */
					}
				});
			});

			var sellingPlanInput = document.querySelector('input[name="selling_plan"]');
			const targetNode = sellingPlanInput;
			const config = {
				attributes: true
			};
			observer.observe(targetNode, config);
			this.on = true;
		},
		updatePricingView: function(selector, widget, updateOriginalPrice = false) {

			window.logDebug('updatePricingView');
			let selectorObject = (widget?.shadowRoot || widget || document).querySelector(selector);
			subscriptionPriceEl = selectorObject;
			//let subscriptionPriceEl = document.querySelector('.subscription-radio .price-label');
			//const amountPrcEl = document.querySelector('.price .amount-prc');
			const prcPriceDiscountEl = document.querySelector('[name="patch2025[_PrcPrice_Discount]"]');

			//SubscriptionAlt Update
			if (prcPriceDiscountEl && subscriptionPriceEl) {
				//let discountAmountUS =`${prcPriceDiscountEl.value} | ${amountPrcEl.value} `;
				/*
				let discountAmountUS = window.calculateDiscountedPrice(subscriptionPriceEl.innerHTML.trim().replace('$', ''), 'string', 'money', {
				  type: 'percent',
				  value: prcPriceDiscountEl.value,
				});*/
				const cleanPrice = subscriptionPriceEl.innerHTML
					.trim()
					.replace(/[^0-9.]/g, '');

				const cleanPercent = prcPriceDiscountEl.value
					.trim()
					.replace(/[^0-9.]/g, '');

				//console.debug('product-.min.js-updateDiscountPrice-DEBUG >>>', cleanPrice,prcPriceDiscountEl.value);
				//console.log('_updatePricingView->>');
				let discountAmountUS = window.applyPercentDiscount(cleanPrice, cleanPercent, 'money');
				//console.debug('product-.min.js-updateDiscountPrice-DEBUG >>>discountAmountUS', discountAmountUS);
				subscriptionPriceEl.innerHTML = ` ${discountAmountUS}`;

				if (updateOriginalPrice) {
					let subscriptionOriginalPriceEl = selectorObject?.closest('[part="rc-purchase-option__prices"]')?.querySelector('[part="rc-purchase-option__original-price"]');

					if (subscriptionOriginalPriceEl) {
						subscriptionOriginalPriceEl.innerHTML = `$${cleanPrice}`;
					}
				}
			}
		},
	};

	// 2025 Depreciated soon to be removed
	window.SubscribeAndSave = (compareAtPriceElement) => {
		var discountObject = {};

		for (const key in window.Recharge) {
			if (key == 'widgets') {
				//console.log(key);
				for (const key2 in window.Recharge[key]) {
					//console.log(key2);
					//discountObject['key1'] = key2;
					discountObject['name_product_id'] = key2;
					//html selling_plan
					for (const key3 in window.Recharge[key][key2]) {
						if (key3 == 'config') {
							//console.log(key3);

							var temp = window.Recharge[key][key2];
							var temp2 = temp[key3];
							//console.log(temp2);
							//console.log(temp[key3]['formattedVariantPrices']);
							//var temp2 = temp[key3]['formattedVariantPrices'];
							for (const key4 in temp2) {
								if (key4 == 'formattedVariantPrices') {
									//console.log(key4);
									//console.log('-----\/');
									//console.log(temp2[key4]);
									var temp3 = temp2[key4];
									for (const key5 in temp3) {
										//console.log(key5);
										//console.log(temp3[key5]);
										//discountObject['key2'] = key5;
										discountObject['id_id_variant'] = key5;
										//html id
										for (const key6 in temp3[key5]) {
											if (key6 == 'formattedSellingPlanPrices') {
												//console.log(key6);
												for (const key7 in temp3[key5][key6]) {
													var temp4 = temp3[key5][key6];
													discountObject['name_selling_plan'] = key7;
													//console.log(key7);
													//console.log(temp4[key7]);
													//console.log(temp4[key7]['discountType']);
													//console.log(temp4[key7]['discountValue']);
													discountObject['discountType'] = temp4[key7]['discountType'];
													discountObject['discountValue'] = temp4[key7]['discountValue'];

													//discountType: "percentage"
													//discountValue: 5
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}

		//console.log(discountObject);
		const prcPriceDiscountEl = document.querySelector('[name="properties[_PrcPrice_Discount]"]');
		if (!prcPriceDiscountEl) return;

		//console.log(prcPriceDiscountEl.dataset.comparePrice);

		//Overide discount value dynamically
		prcPriceDiscountEl.value = discountObject.discountValue ? discountObject.discountValue : 0;

		//const prcPriceDiscountUndiscounted_value = prcPriceDiscountEl.dataset.comparePrice;

		//name=properties[_PrcPrice_Discount]
		//console.log(discountObject.discountValue);

		if (discountObject.discountValue > 0) {
			const sellingPlanEl = document.querySelector('[name="selling_plan"]');
			if (sellingPlanEl) {
				let prcPriceDiscount = {
					value: 0,
				};
				prcPriceDiscount.value = discountObject.discountValue;

				//console.debug('UPDATE DISCOUNT');
				//console.debug('UPDATE DISCOUNT');

				const prcPriceEl = document.querySelector('[name="properties[_PrcPrice]"]');

				/* 
				const compareAtPrice = prcPriceDiscountUndiscounted_value;
				let discountAmount = compareAtPrice - compareAtPrice * Number(prcPriceDiscount.value) * 0.01;
				let USDollar = new Intl.NumberFormat('en-US', {
				  style: 'currency',
				  currency: 'USD',
				});

				const discountAmountUS = USDollar.format(discountAmount);
				const discountAmountWithoutCurrency = discountAmountUS.replace(/^\D+/g, '');
				discountAmount = discountAmountWithoutCurrency;
				//console.log("UPDATE SELLING PLAN");
				console.log(discountAmountUS);
				console.log(discountAmount);
				//compareAtPriceElement.value = discountAmountUS;
				//prcPriceEl.value = discountAmount;

				*/
			} else {
				//REVERT TO Basic Compare Price
				//console.log("RESET");
			}
		}

		window.SubscribeAndSaveObserver.startObserver();
	};


	window.updateRechargeFrequencyPlacement = () => {
		//2024 - UPDATE FREQUENCY
		const subscriptionFrequencyEl = document.querySelector('.subscription-widget-active-frequency-on-true');
		const subscriptionLabelEl = document.querySelector('.subscription-radio .rc-radio__label');
		const rcSellingPlans = document.querySelector('.rc-selling-plans');
		//console.log(subscriptionFrequencyEl);
		if (subscriptionFrequencyEl && subscriptionLabelEl && rcSellingPlans) {
			window.logDebug('updateRechargeFrequencyPlacement');
			subscriptionLabelEl.appendChild(rcSellingPlans);
		}
	};


	window.modifyRechargePrices_OneTimePrice = (selector, price, widget) => {
		//const = price_conv = window.calculateDiscountedPrice(price, 'string');
		// return;
		//window.logDebug('modifyRechargePrices_OneTimePrice',selector,widget);
		//const selectorObject = document.querySelector(selector);
		const selectorObject = (widget?.shadowRoot || widget || document).querySelector(selector);
		//console.log(selectorObject);
		if (selectorObject) {
			//console.debug('modifyRechargePrices_OneTimePrice-DEBUG', selectorObject);
			selectorObject.innerHTML = `${selectorObject.innerText.split('$')[0]}${price}`;
			//console.debug('modifyRechargePrices_OneTimePrice', price);
			//console.debug('_OneTimePrice');
		}
	};


	window.modifyRechargePrices_Subscription = (selector, price, widget) => {
		// return;
		//window.logDebug('modifyRechargePrices_Subscription',selector,widget);
		//const selectorObject = document.querySelector(selector);
		const selectorObject = (widget?.shadowRoot || widget || document).querySelector(selector);
		//window.logDebug('modifyRechargePrices_Subscription',selector,widget,selectorObject);
		if (selectorObject) {
			selectorObject.innerHTML = ` ${price}`;
			//console.debug('modifyRechargePrices_Subscription', price);
			console.debug('_Subscription', price);
		}
	};


	window.modifyRechargePrices_SubscriptionAlt = (selector, price, widget) => {
		// return;
		const selectorObject = document.querySelector(selector);
		if (selectorObject) {
			selectorObject.innerHTML = ` ${price}`;
			//console.debug('modifyRechargePrices_SubscriptionAlt', price);
			console.debug('_SubscriptionAlt');
		}
	};

	//product-title-container
	//updateDisplayedPrice >> updateProductTitleContainer
	window.updateProductTitleContainer = (purchaseOption) => {
		//window.logDebug('updateProductTitleContainer');
		//console.log(purchaseOption);
		const label = purchaseOption?.closest('label');
		//2025 UPDATE RECHARGE PRICE SELECTION
		const priceEl = label?.querySelector('div.price-label,.rc-radio__label,.rc-purchase-option__prices');
		//const priceElValue = priceEl?.textContent.trim().split('$').pop() ? `$${priceEl.textContent.trim().split('$').pop()}` : null;
		const priceElValue = priceEl?.textContent ? priceEl.textContent.trim().split('$').pop().trim() : null;
		//console.log(label);
		//console.log(priceElValue);

		//console.debug('updateProductTitleContainer-DEBUG:label', label);
		//console.debug('updateProductTitleContainer-DEBUG:priceEl', priceEl);
		//console.debug('updateProductTitleContainer-DEBUG:priceElValue', priceElValue);
		//amount-discount
		//amount
		// Traverse to .recharge-subscription-widget → then get its sibling
		// 2025  Dynamic price Update
		let rcWidgetEl = purchaseOption.closest('.recharge-subscription-widget, recharge-subscription-widget');
		// Normalize for shadow DOM if it's v2
		rcWidgetEl = rcWidgetEl?.shadowRoot || rcWidgetEl;

		const priceContainer = rcWidgetEl?.previousElementSibling?.classList.contains('product-title-container') ?
			rcWidgetEl.previousElementSibling :
			null;

		//console.log(purchaseOption);

		if (!priceContainer) return;
		//console.debug('updateProductTitleContainer-DEBUG>>priceContainer', priceContainer);
		//const prcSpan = priceContainer.querySelector('.amount-prc');
		/* 2025  Dynamic price Update */
		const discountSpan = priceContainer.querySelector('.amount-discount:not(.no-dynamic)');
		const amountSpan = priceContainer.querySelector('.amount:not(.no-dynamic)');
		const discountFlag = document.body.hasAttribute('has-discount') && document.body.getAttribute('has-discount') !== '';
		if (discountFlag) {
			if (discountSpan) {
				discountSpan.innerHTML = priceElValue;
			}
		} else {
			if (amountSpan) {
				amountSpan.innerHTML = priceElValue;
			}
		}
		//console.debug('updateProductTitleContainer-DEBUG>>discountFlag', discountFlag);
	};



	window.updateDisplayedCount = (countOption) => {
		console.debug('updateDisplayedCount-DEBUG>>countOption', countOption);
	};


	window.modifyRechargePrices = async () => {
		window.logDebug('modifyRechargePrices');
		const formEl = document.querySelector('#product-form-installment');
		const compareAtPriceEl = formEl ? formEl.querySelector('[name="amount_discount"]') : false;
		const compareAtPriceListEl = formEl ? formEl.querySelector('[name="amount_discount_list"]') : false;

		if (!compareAtPriceEl) return;

		// let rcWidgetEl = await findElementAsync('.rc-widget, recharge-subscription-widget');
		let rcWidgetEl;
		try {
			rcWidgetEl = await findElementAsync('.rc-widget, recharge-subscription-widget');
		} catch (err) {
			//2026 Global Polling Settings update
			const waitMs = window.polling_settings.interval * window.polling_settings.maxAttempts;
			const waitSec = (waitMs / 1000).toFixed(1);
			window.logDebug(
				`[Recharge] Widget never appeared after ~${waitSec}s; skipping dynamic price wiring.`,
				err
			);
			return;
		}
		rcWidgetEl = rcWidgetEl?.shadowRoot || rcWidgetEl;

		// Normalize for shadow DOM if it's v2
		rcWidgetEl = rcWidgetEl?.shadowRoot || rcWidgetEl;

		//11/2023
		window.clearInfoMessage();
		//2024
		window.updateRechargeFrequencyPlacement();

		//2025
		//console.debug('updateProductTitleContainer-DEBUG >>> A',rcWidgetEl);
		if (rcWidgetEl) {
			rcWidgetEl.querySelectorAll('input[name="purchaseOption"]').forEach(radio => {
				//console.log(radio);
				radio.addEventListener('change', function() {
					window.logDebug('modifyRechargePrices>>change');
					window.updateProductTitleContainer(this);
				});
			});

			setTimeout(() => {
				const selected = rcWidgetEl.querySelector('input[name="purchaseOption"]:checked');
				if (selected) {
					//console.debug('updateProductTitleContainer-DEBUG >>> SELECTED', selected);
					window.logDebug('modifyRechargePrices>>selected');
					window.updateProductTitleContainer(selected);
				}
			}, 500); // Delay in milliseconds

			/*const variantSelects = document.querySelector('variant-selects');
			variantSelects.querySelectorAll('input[name="Option"]').forEach(radio => {
			  radio.addEventListener('change', function () {
			    window.updateDisplayedCount(this);
			  });
			*/

			//const rcWidget = purchaseOption.closest('.recharge-subscription-widget');
			document.querySelectorAll('.variations input[name="Option"]').forEach(radio => {
				radio.addEventListener('change', function() {
					const selected = rcWidgetEl.querySelector('.rc-radio--active input[name="purchaseOption"]');
					// console.debug('updateProductTitleContainer-DEBUG >>> B',selected);
					// if (selected) window.updateProductTitleContainer(selected);
				});
			});

		}

		if (!rcWidgetEl || !window.prc.isValid) return;

		//console.debug('modifyRechargePrices B',window.prc.isValid);

		//2024
		//2025 Depreciated NOT NEEDED
		//window.SubscribeAndSave(compareAtPriceEl);

		let compareAtPrice = compareAtPriceEl.value;

		if (compareAtPriceEl) {
			//console.debug(compareAtPrice);
			//console.debug(compareAtPriceEl);
		}

		const variantInputEls = document.querySelectorAll('.variations input[type="radio"]');
		const prcPriceEl = document.querySelector('[name="properties[_PrcPrice]"]');

		const update = () => {
			setTimeout(function() {
				window.logDebug('update price >> setTimeout', rcWidgetEl);
				//MODIFY RECHARGE PRICE OPTIONS HERE 2023!!!
				//2025 UPDATE
				window.modifyRechargePrices_OneTimePrice('.onetime-radio .rc-radio__label, [part~="rc-purchase-option__onetime"] .rc-price', compareAtPrice, rcWidgetEl);
				//.rc-selection__onetime .rc-price

				//2025 UPDATE
				window.modifyRechargePrices_Subscription('.subscription-radio .rc-radio__price, [part~="rc-purchase-option__subscription"] .rc-price[part~="rc-purchase-option__discounted-price"]', compareAtPrice, rcWidgetEl);

				//UPDATE FOR ALT VIEW
				window.modifyRechargePrices_SubscriptionAlt('.subscription-radio .price-label', compareAtPrice, rcWidgetEl);

				//UPDATE FOR SUBSCRIBE & SAVE
				window.SubscribeAndSaveObserver.updatePricingView('.subscription-radio .rc-radio__price,.subscription-radio .price-label, [part~="rc-purchase-option__subscription"] .rc-price[part~="rc-purchase-option__discounted-price"]', rcWidgetEl, window.product_min_param_settings.discount_config_subnsave_original_price_enable);
			}, 100);

			const priceMutationEl = rcWidgetEl.querySelector('[data-price-mutation-watcher]');
			if (!priceMutationEl) return;

			priceMutationEl.removeAttribute('data-price-mutation-watcher');
			const priceEl = priceMutationEl.querySelector('.recharge-inner-most-price');
			if (priceEl) priceEl.innerHTML = compareAtPrice;
		};

		const matchers = (value) => {
			console.debug('matchers-DEBUG');
			const foundOption = Array.from(compareAtPriceListEl.options).find((option) => option.text === value);
			if (!foundOption) return;

			compareAtPrice = foundOption.value;
			compareAtPriceEl.value = foundOption.value;
			if (prcPriceEl) prcPriceEl.value = foundOption.dataset.price;

			if (prcPriceEl) {
				console.debug('product-.min.js-matchers-DEBUG', prcPriceEl.value);
			}
			console.debug('product-.min.js-matchers-DEBUG', compareAtPriceEl.value);
		};

		update();

		if (!compareAtPriceListEl) return;

		variantInputEls.forEach((el) => {
			if (el.checked) matchers(el.value);
			el.addEventListener('change', (e) => {
				matchers(e.target.value);
				update();
			});
		});
	};

	if (!window.has_noRecharge_tag) {
		if (typeof onUserInteraction === 'function') {
			onUserInteraction(window.modifyRechargePrices);
		} else {
			window.modifyRechargePrices();
		}
	}

});